import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { CategoriaPermissao } from 'src/app/admihair/api/dto/categoria-permissao';
import { Permissao } from 'src/app/admihair/api/dto/permissao';
import { CategoriaPermissaoService } from 'src/app/admihair/service/categoria-permissao.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PermissaoService } from 'src/app/admihair/service/permissao.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-permissao-inserir',
  templateUrl: './permissao-inserir.component.html',
  styleUrls: ['./permissao-inserir.component.scss']
})
export class PermissaoInserirComponent implements OnInit {
  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  tipos: String[] = ['EMPRESA', 'FRANQUIA'];
  categoriasPermissoes: CategoriaPermissao[] = [];


  constructor(private permissaoService: PermissaoService,
    private categoriaPermissaoService: CategoriaPermissaoService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;

  ngOnInit(): void {
    this.listarCategorias();
  }

  salvar(){
    this.progressoRequisicao = true;
    const permissao = this.form?.value;
    console.log(permissao)
    
    this.permissaoService.salvar(permissao).subscribe({
      next: (data: Permissao) => {
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.limparFormulario();
        this.rolarTela();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      }
    });
  }

  listarCategorias(){
    this.categoriaPermissaoService.listarTodos().subscribe({
      next: (data: CategoriaPermissao[]) => {
        this.categoriasPermissoes = data;
        console.log(this.categoriasPermissoes)
      },
      error: (err: any) => {

      }
    });
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }
  limparFormulario(){
    this.form?.reset(); 
  }
  
  ocultarMsg(){
    this.messagemVisivel = false;
  }
  
}
